import { Dispatch } from "react";
import {
  ICustomDropdownDispatchProps,
  ICustomDropdownOptionProps,
  IMdcLineChartAxis,
  IMdcProductFamily
} from "../../../interfaces/customer-product-v2.interfaces";
import { DropdownReducerType } from "../../../Utils/Enums/Customer.constants";

export const retrieveDataPoints = (apiData: IMdcProductFamily[]) =>
  apiData
    .flatMap((x) => x.data)
    .flatMap((s) => s.data)
    .flatMap((series) => series.data);

export const aggregateByCloudSet = (points: IMdcLineChartAxis[]) =>
  points.reduce(
    (acc, { cloud, aggregationType }) => {
      if (!cloud || !aggregationType) return acc;
      (acc[cloud] ??= new Set()).add(aggregationType);
      return acc;
    },
    {} as Record<string, Set<string>>
  );

export const dispatchLoadMenuItems =
  (dispatch: Dispatch<ICustomDropdownDispatchProps>) => (items?: ICustomDropdownOptionProps[]) => {
    dispatch({ type: DropdownReducerType.LoadItems, data: items || [] });
  };

export const dispatchMenuItemsUpdate = (dispatch: Dispatch<ICustomDropdownDispatchProps>) => (item?: string) => {
  dispatch({ type: DropdownReducerType.UpdateSelectedItem, data: item || "" });
};

export const mapFilterPillMenuItemsPredicate = (value: string): ICustomDropdownOptionProps => ({ value, text: value });

// Helper function to get selected value or fallback to first option
export const getSelectedOrDefault = (state: { options: ICustomDropdownOptionProps[]; selectedItem: string }): string =>
  state.selectedItem || state.options.at(0)?.text || "";

export const dropdownReducer = (
  state: { options: ICustomDropdownOptionProps[]; selectedItem: string },
  action: { type: DropdownReducerType; data: ICustomDropdownOptionProps[] | string }
) => {
  switch (action.type) {
    case DropdownReducerType.LoadItems:
      return { ...state, options: action.data as ICustomDropdownOptionProps[] };
    case DropdownReducerType.UpdateSelectedItem:
      return { ...state, selectedItem: action.data as string };
    default:
      return state;
  }
};
